import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";
import InterestDaysInYear from "@/models/Products/InterestDaysInYear";
import InterestNonWorkingDays from "@/models/Shared/NonWorkingDays";
import InterestRateType from "@/models/Products/InterestRateType";
import PeriodType from "@/models/Shared/PeriodType";
import DayOfWeek from "@/models/Shared/DayOfWeek";
import Month from "@/models/Shared/Month";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";
import Amount from "@/models/Shared/Amount";

export default class DepositOverdraftInterestSettings extends BaseProductSettings {
    enabled: boolean = true;
    interestBearingThreshold: Amount = new Amount();
    rateType: InterestRateType = InterestRateType.Fixed;
    rateValue: number = 0;
    cumulativeRateValue: number = undefined;
    rateSourceId: string;
    rateSourceIdentifier: EntityIdentifier;
    accruedPeriodType: PeriodType = PeriodType.Day;
    accruedPeriodValue: number = 1;
    accruedPeriodOnDayOfWeek: DayOfWeek = undefined;
    accruedPeriodOnDayOfMonth: number = undefined;
    accruedPeriodOnMonth: Month = undefined;
    calculatedOnBalanceType: InterestCalculatedOnBalanceType = InterestCalculatedOnBalanceType.EndOfDayBalance;
    postedPeriodType: PeriodType = PeriodType.Month;
    postedPeriodValue: number = 1;
    postedPeriodOnDayOfWeek: DayOfWeek = undefined;
    postedPeriodOnDayOfMonth: number = undefined;
    postedPeriodOnMonth: Month = undefined;
    daysInYearType: InterestDaysInYear = InterestDaysInYear.Actual365;
    nonWorkingDaysType: InterestNonWorkingDays = InterestNonWorkingDays.NextWorkingDay;
}